import React from "react";
import MonitoringTabsPanel from "components/common/MonitoringTabsPanel";
import MonitoringDashboard from "pages/Monitoring/MonitoringDashboardPage";
import MonitoringFormProvider from "providers/MonitoringProvider";

const MonitoringUniversalPage: React.FC = () => (
  <MonitoringTabsPanel>
    {(tab) => (
      <MonitoringFormProvider>
        <MonitoringDashboard tab={tab} />
      </MonitoringFormProvider>
    )}
  </MonitoringTabsPanel>
);

export default MonitoringUniversalPage;
